import { MyEmergencyPlanFormSchema } from '@/features';

export const ref18TrueValues: Array<MyEmergencyPlanFormSchema['ref15'][number]> = ['livestock-and-other-animals'];
